module.exports = __webpack_public_path__ + "assets/images/img/04.8e28937048cc4f5c72d3c61985c6f9b4.jpg";